module.exports = __webpack_public_path__ + "img/4.de3fc84a.jpg";